















import Vue from 'vue'

export default Vue.extend({
  data () {
    return {
      path: 'setting'
    }
  },
  mounted () {
    window.addEventListener('keyup', this.callEvent)
  },
  methods: {
    callEvent (event: KeyboardEvent) {
      if (event.keyCode === 13) {
        this.$router.push(this.path)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.callEvent)
  }
})
